import { Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  private defaultLang = 'eg';

  constructor(
    private translocoService: TranslocoService
  ) {}


  setLanguage(lang: string): void {

    this.translocoService.setActiveLang(lang);

    localStorage.setItem(
      'app-lang',
      lang
    );


    // document.documentElement.dir =
    //   lang === 'eg'
    //     ? 'rtl'
    //     : 'ltr';

  }



  getLanguage(): string {

    return (
      localStorage.getItem('app-lang')
      ??
      this.defaultLang
    );

  }



  initLanguage(): void {

    const lang =
      this.getLanguage();


    this.translocoService.setActiveLang(lang);


    document.documentElement.dir =
      lang === 'eg'
        ? 'rtl'
        : 'ltr';

  }

}